"use client";

import { useState } from "react";
import { bankAccountOptions } from "../../../../utils/options_selects";
import CardSelect from "../../../../components/new_components/CardSelcted";
import { ReactComponent as OptionsCardsIcon } from "../../../../public/svg/optionsCards.svg";

// Bancos con flujo Wompi predefinido
const WOMPI_BANK_VALUES = [21, 30, 31]; // Bancolombia, Nequi, Daviplata

/**
 * BankFlowSelector
 *
 * Props:
 *  - isDesktop: boolean
 *  - initialBank: number | string — banco preseleccionado (si hay)
 *  - onComplete: ({ bankAccount }) => void — notifica al padre cuando el flujo termina
 */
const BankFlowSelector = ({ isDesktop, initialBank, onComplete, onBankChange  }) => {
  const [selectedBank, setSelectedBank] = useState(0);

  const wrapIcon = (icon) => (
    <div
      className="bg-[#baa7d52e] flex items-center"
      style={{
        borderRadius: "50px",
        padding: "10px",
        width: "3rem",
        height: "3rem",
      }}
    >
      {icon}
    </div>
  );
  const paymentMethodOptions = [
    {
      value: 1,
      label: "Tarjetas",
      description: "Debito o Credito",
      icon: wrapIcon(
        <OptionsCardsIcon
          style={{
            width: "clamp(24px, 2vw, 40px)",
            height: "clamp(24px, 2vw, 40px)",
          }}
        />,
      ),
      iconSelected: wrapIcon(
        <OptionsCardsIcon
          style={{
            width: "clamp(24px, 2vw, 40px)",
            height: "clamp(24px, 2vw, 40px)",
          }}
        />,
      ),
    },
    ...bankAccountOptions
      .filter(({ value }) => WOMPI_BANK_VALUES.includes(value))
      .map((bank) => ({
        ...bank,
        label: bank.label,
        icon: wrapIcon(bank.icon2),
        iconSelected: wrapIcon(bank.icon2),
        description: `Cuenta ${bank.label}`,
      })),
  ];

  // Cuando el flujo hijo termina, sube los datos al padre

  const handleBankChange = (data) => {
    const val = Number(data.target.value);
    setSelectedBank(val); // ← actualiza estado local → card queda seleccionada
    onBankChange?.(val);
  };

  // Mientras no se elige banco: mostrar selector
  return (
    <div
      style={{
        height: isDesktop ? "-webkit-fill-available" : "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between", // ← cards arriba, botones abajo
        gap: "24px",
        padding: isDesktop ? "0" : "0 16px",
        width: "100%",
      }}
    >
      {/* Cards */}
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <div style={{ width: "100%", maxWidth: isDesktop ? "500px" : "384px" }}>
          <CardSelect
            data={paymentMethodOptions}
            name="paymentMethod"
            value={selectedBank}
            onChange={handleBankChange}
            multiple={false}
            isDesktop={isDesktop}
          />
        </div>
      </div>
    </div>
  );
};

export default BankFlowSelector;
